import ReferenceCheckStepView from "./ReferenceCheckStepView";

function ReferenceCheckStep({ controller }) {
  const references = controller.visitorData.reference ?? [""];

  /**
   * This method will handle the reference change event
   * @param {event} e
   * @param {int} index
   */
  function onReferenceChange(e, index) {
    const newReferences = [...references];
    newReferences[index] = e.target.value;

    controller.setVisitorData({
      ...controller.visitorData,
      reference: newReferences,
    });
  }

  /**
   * This method will add an empty reference
   */
  function onReferenceAdd() {
    controller.setVisitorData({
      ...controller.visitorData,
      reference: [...references, ""],
    });
  }

  /**
   * This method will remove the reference at the given index
   * @param {int} index
   */
  function onReferenceRemove(index) {
    controller.setVisitorData({
      ...controller.visitorData,
      reference: references.filter((reference, i) => i !== index),
    });
  }

  return (
    <ReferenceCheckStepView
      controller={controller}
      references={references}
      onReferenceChange={onReferenceChange}
      onReferenceAdd={onReferenceAdd}
      onReferenceRemove={onReferenceRemove}
    />
  );
}

export default ReferenceCheckStep;